import 'css-chunksrc/client/pages/utilityPage/projectPage/styles.scss';export default {
  "projectStatusesList": "_projectStatusesList_kyijh_1"
};